import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { assertCurrentUser } from "lib/currentUser";
import { graphql } from "lib/generated/app-service-gql";
import {
  BidQuestionGroupsQuery,
  BidQuestionGroupsQueryVariables,
} from "lib/generated/app-service-gql/graphql";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "lib/hooks/api/utils";
import { useGraphQlQuery } from "../../useGraphQlClient";

const bidQuestionGroupsQuery = graphql(`
  query bidQuestionGroups {
    bidQuestionGroups {
      groups {
        name
        questions {
          id
          title
          question
          groupName
          promptId
          order
          teamId
          companyId
          autoQualify
        }
      }
    }
  }
`);

type GetQuestionsByTeamResponse = BidQuestionGroupsQuery["bidQuestionGroups"];
export type BidQuestionGroupDto = GetQuestionsByTeamResponse["groups"][0];
export type BidQuestionObj = BidQuestionGroupDto["questions"][0];

export function useBidQuestions(
  options?: UseQueryOptions<BidQuestionGroupsQuery, unknown, BidQuestionGroupsQuery, QueryKey>,
) {
  const teamId = assertCurrentUser().team.id;
  const { data, ...rest } = useGraphQlQuery<
    BidQuestionGroupsQuery,
    BidQuestionGroupsQueryVariables
  >(["bid_questions", teamId], bidQuestionGroupsQuery, [], {
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
    ...options,
    enabled: !!teamId,
  });

  return { data: data?.bidQuestionGroups, ...rest };
}
